import { render, staticRenderFns } from "./DisableEmail.vue?vue&type=template&id=1304f701&scoped=true&"
import script from "./DisableEmail.vue?vue&type=script&lang=ts&"
export * from "./DisableEmail.vue?vue&type=script&lang=ts&"
import style0 from "./DisableEmail.vue?vue&type=style&index=0&id=1304f701&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1304f701",
  null
  
)

export default component.exports